import React, { Component } from "react";
import { Card, Tooltip } from "antd";
import moment from "moment";
import { Translate } from "react-translated";
const today = new Date();

class StatBox extends Component {
  render() {
    const {
      title,
      val,
      color,
      user_type,
      history,
      period,
      start_date,
      end_date,
      link,
      gridStyleWidth,
      isvonboarderpermit
    } = this.props;

    const gridStyle = {
      width: gridStyleWidth,
      textAlign: "center",
      backgroundColor: (title === "Sent for Virtual Follow Up"&& isvonboarderpermit === 0)? "#efefef":"",
    };
    const from =
      period === "all_bfiles"
        ? moment(new Date("2010-01-01")).format("YYYY-MM-DD")
        : start_date;
    const to =
      period === "all_bfiles"
        ? moment(new Date("2050-01-01")).format("YYYY-MM-DD")
        : end_date;

    return (
      <Card.Grid style={gridStyle} className={"card-" + color}>
        <Tooltip placement="bottom" title={`${val}`}>
          <div className="value">
            {user_type !== "AGENCY_MANAGER" ? (
              <button style={{background:'transparent',border:'none',cursor:isvonboarderpermit === 0?'not-allowed':'pointer'}} disabled={isvonboarderpermit === 0}
                onClick={() => {
                  history.push(link, {
                    from,
                    to,
                  });
                }}
              >
                {val}
              </button>
            ) : (
              val
            )}
          </div>
        </Tooltip>
        <div className="title">
          <Translate text={title} />
        </div>
      </Card.Grid>
    );
  }
}
export default StatBox;



// WEBPACK FOOTER //
// ./src/components/stat-box.js